import { getGlobalObject } from '@datadog/browser-core';
export function isProfilingSupported() {
    const globalThis = getGlobalObject();
    // This API might be unavailable in some browsers
    const globalThisProfiler = globalThis.Profiler;
    return globalThisProfiler !== undefined;
}
//# sourceMappingURL=profilingSupported.js.map